/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S41_Item_2Inputs */

const es_tyc_obligations_s41_item_2 = /** @type {(inputs: Tyc_Obligations_S41_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar credenciales y permisos para esas Fuentes Conectadas.`)
};

const en_tyc_obligations_s41_item_2 = /** @type {(inputs: Tyc_Obligations_S41_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage credentials and permissions for those Connected Sources.`)
};

/**
* | output |
* | --- |
* | "Manage credentials and permissions for those Connected Sources." |
*
* @param {Tyc_Obligations_S41_Item_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s41_item_2 = /** @type {((inputs?: Tyc_Obligations_S41_Item_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S41_Item_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s41_item_2(inputs)
	return en_tyc_obligations_s41_item_2(inputs)
});
export { tyc_obligations_s41_item_2 as "tyc.obligations.s41_item_2" }